export default "__VITE_ASSET__DLA3ZlVV__"